import { IRestaurant } from './IRestaurant';
import { ICategory } from './ICategory';
import { IUser } from './IUser';
import { PermissionType } from '../enums/PermissionType';
import { IBranch } from './IBranch';

export enum MemberRole {
  Owner = 'owner',
  Admin = 'admin',
  Custom = 'custom',
}

export interface IMember {
  userId: number;
  user?: IUser;
  restaurantId: number;
  restaurant?: IRestaurant;
  type: MemberRole;
  description?: string;
  permissions?: number;
  branches?: IBranch[];
  allBranches: boolean;
  allCajas: boolean;
  cajaIds?: number[];
  /** Whether the member's user has a PIN configured (GET /:id/members only). */
  hasPin?: boolean;
  createdAt: Date;
  updatedAt: Date;
}
